import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'

const modelName = 'product'

export function get () {
  return {
    types: generateTypes(`${modelName}s`),
    api: api => api(`${modelName}s`)
  }
}

export const actions = {
  get
}

// Action Handlers
const initialState = []
function getTempId (model) {
  return `${model.name}:${model.type_id}`
}
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName, getTempId })

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Products/modules/products.js